<div class="container">
  <div class="row">
    <div class="table-responsive">
      <div class="bn-form-group col-md-6">
        <th scope="col"><b>Saldo de principal atual:</b></th>
        <input type="text" class="form-control" [value]="saldo?.valorEmUnidadeMonetaria | bnMask: 'MOEDA.5'" disabled />
       </div>
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col"><b>Data Amortização</b></th>
            <th scope="col"><b>Valor da Amortização</b></th>
          </tr>
        </thead>
        <tbody *ngFor="let amortizacao of amortizacoes">
            <td>{{amortizacao.dataCompetencia | date: 'dd/MM/yyyy' }}</td>
            <td>{{amortizacao.valorEmReais | bnMask: 'MOEDA' }}</td>
        </tbody>
      </table>
    </div>
